export default "__VITE_ASSET__Tpbhe0sy__"